import { useMutation } from '@apollo/client/react';
import { useEffect, useMemo } from 'react';

import {
  FetchLineAccountProfileDocument,
  LineVisitorOfOutpatientQuestionnaireEntryDetailFragment,
} from '~/graphql/generated/graphql';

type Props = {
  visitor: LineVisitorOfOutpatientQuestionnaireEntryDetailFragment;
};

export const useFetchLineProfile = ({ visitor }: Props) => {
  const [fetchLineAccountProfile, { data }] = useMutation(FetchLineAccountProfileDocument);
  const active = useMemo(() => !!data?.fetchLineAccountProfile?.lineVisitor?.active, [data]);

  useEffect(() => {
    if (visitor?.__typename !== 'LineVisitor' || !visitor.id) {
      return;
    }

    fetchLineAccountProfile({
      variables: {
        input: {
          lineVisitorId: visitor.id,
        },
      },
    });
  }, [fetchLineAccountProfile, visitor]);

  return { active };
};
